import {Controller} from "@stubhub/react-store-provider";

const controller = new Controller({
  namespace: "sell",
  reducers: [""],
  mapStateToProps: function(state) {
    const {type: deviceType} = state.device;
    const {shstoreId} = state.gsConfig;
    const localState = this.getLocalState(state);
    const {lang} = state;
    return {...localState.data, shstoreId, deviceType, lang};
  },
  actionCreators: {}
});

export default controller;
